import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { ServiceResponse } from '../../../../../app/services/shared/interfaces';
import ButtonCancelForm from '../../../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../../../components/buttons/ButtonSaveForm';
import useWarehouseQuoteExpeditionService from '../../../../../app/services/hooks/useWareHouseQuoteExpeditionService';
import { WarehouseExpeditionDataForm } from '../../../../../app/models/WareHouseQuoteExpedition';
import WarehouseExpeditionForm from './forms/WareHouseExpeditionForms/WareHouseExpeditionForm';
import { Depot } from '../../../../../app/models/Depot';
import { Currency } from '../../../../../app/models/Currency';
import { Unit } from '../../../../../app/models/Unit';
import { RouteSegment } from '../../../../../app/models/RouteSegment';
import { Place } from '../../../../../app/models/Place';
import { AppContext } from '../../../../../contexts/AppContext';
import { PackingType } from '../../../../../app/models/PackingType';
import useReactConfirmAlert from '../../../../../hooks/useReactConfirmAlert';

interface Props {
    quoteId: number;
    onSaved: () => void;
    onCancel: () => void;
    onError?: () => void;
}

const WarehouseQuoteExpeditionCreate = ({ quoteId, onSaved, onCancel, onError }: Props) => {
    const {
        createWarehouseQuoteExpedition,
        storeWarehouseQuoteExpedition,
        fetchingCreateWarehouseQuoteExpedition
    } = useWarehouseQuoteExpeditionService();

    const [form, setForm] = useState<WarehouseExpeditionDataForm>({
        quote_id: quoteId,
        place_id: 0,
        // destination_id: 0,
        depot_id: 0,
        route_segment_id: 0,
        unit_id: 0,
        currency_id: 0,
        rate: 0,
    });

    const [origins, setOrigins] = useState<Place[]>([]);
    const [destinations, setDestinations] = useState<Place[]>([]);
    const [depots, setDepots] = useState<Depot[]>([]);
    const [routeSegments, setRouteSegments] = useState<RouteSegment[]>([]);
    const [currencies, setCurrencies] = useState<Currency[]>([]);
    const [units, setUnits] = useState<Unit[]>([]);
    const [packingTypes, setPackingTypes] = useState<PackingType[]>([]);
    const [errorFields, setErrorFields] = useState<any>();

    const { hideLoading, showLoading } = useContext(AppContext);

    const create = () => {
        createWarehouseQuoteExpedition(quoteId, {
            onSuccess: (response: ServiceResponse) => {
                setOrigins(response.data.origins);
                setDestinations(response.data.destinations);
                setDepots(response.data.depots);
                setRouteSegments(response.data.route_segments);
                setCurrencies(response.data.currencies);
                setUnits(response.data.units);
                setPackingTypes(response.data.packing_types);

                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                onError && onError();
            }
        });
    };

    useEffect(() => {
        create();
    }, []);

    const store = () => {
        storeWarehouseQuoteExpedition(form, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },

            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setErrorFields(errorFields.data);
            }
        });
    };

    if (fetchingCreateWarehouseQuoteExpedition) {
        return <p>Cargando datos de expedición…</p>;
    }

    return (
        <>
            <WarehouseExpeditionForm
                expeditionDataForm={form}
                setExpeditionDataForm={setForm}
                origins={origins}
                destinations={destinations}
                depots={depots}
                routeSegments={routeSegments}
                currencies={currencies}
                units={units}
                packingTypes={packingTypes}
                errorFields={errorFields}
            />
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={onCancel} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={store} />
                </div>
            </div>
        </>
    );
};

export default WarehouseQuoteExpeditionCreate;
